import axios from 'axios';
import api from './client';
import { useApiConfigStore } from '@store/api_config';

export interface MaintenanceStatus {
  active: boolean;
  message: string;
  estimated_end: string;
  activated_by: string;
  activated_at: string;
}

const publicClient = axios.create();
publicClient.interceptors.request.use((config) => {
  config.baseURL = useApiConfigStore.getState().getApiUrl();
  return config;
});

export const activateMaintenance = (data: {
  message: string;
  estimated_end: string;
}): Promise<MaintenanceStatus> =>
  api.post('/maintenance/activate', data).then((r) => r.data);

export const deactivateMaintenance = (): Promise<MaintenanceStatus> =>
  api.post('/maintenance/deactivate').then((r) => r.data);

export const getMaintenanceStatus = (): Promise<MaintenanceStatus> =>
  publicClient.get('/maintenance/status').then((r) => r.data);
